<template>
  <div>
    <container>
      <template slot="title">Вход в личный кабинет</template>

      <template slot="actions">
        <v-btn
          color="info"
          :large="$vuetify.breakpoint.smAndUp"
          :disabled="!valid"
          @click="do_login"
        >
          <v-icon left>mdi-lock</v-icon>
          Вход
        </v-btn>
      </template>

      <v-form v-model="valid" @submit.prevent>
        <v-text-field
          v-model="login"
          label="Логин"
          type="text"
          name="login"
          :rules="rule_required"
        ></v-text-field>

        <v-text-field
          v-model="password"
          label="Пароль"
          type="password"
          name="password"
          :rules="rule_required"
        ></v-text-field>

        <template v-if="debug.value">
          <v-btn
            v-for="u in debug.users"
            :key="u.name"
            @click="
              login = u.login;
              password = u.password;
              do_login();
            "
          >
            {{ u.name }}
          </v-btn>
        </template>
      </v-form>
    </container>

    <v-snackbar v-model="alert">
      {{ alert_text }}
      <v-btn text @click="alert = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Container from "@/components/Container.vue";
import { Auth } from "../api/common";

export default {
  name: "Login",
  components: { Container },
  data() {
    return {
      login: null,
      password: null,
      alert: null,
      alert_text: "",
      valid: true,
      rule_required: [(v) => !!v || "Обязательное поле"],
      redirect: "/",
      visible: false,
      debug: {},
    };
  },
  created() {
    const { login, password } = this.$route.query;
    if (login && password) {
      this.login = login;
      this.password = password;
      this.do_login();
      return;
    }

    if (process.env.NODE_ENV === "development") {
      const users = [
        { name: "Диспетчер", login: "74941", password: "84017" },
        { name: "Заказчик (физик)", login: "94960", password: "50018" },
        // { name: "Заказчик (физик)", login: "69575", password: "77540" },
        // { name: "Водитель", login: "19665", password: "66631" },
        { name: "Водитель", login: "32132", password: "65465" },
        { name: "Администратор", login: "385016", password: "789004" },
        { name: "Супервизор", login: "41658", password: "22060" },
        { name: "Рубцовск1 (lite)", login: "97666", password: "26400" },
        { name: "Пастушенко (lite)", login: "93974", password: "22857" },
      ];

      this.$set(this.debug, "value", true);
      this.$set(this.debug, "users", users);
    }
  },
  methods: {
    async do_login() {
      let response = await Auth.login(this.login, this.password);
      const { status, default_router } = response;
      if (status == "Ok") {
        this.$router.push(default_router ?? "/");
      } else {
        this.$root.$emit("server-error", response);
      }
    },
  },
};
</script>
